/* WhFloatingAi (iter455) — Floating AI Assistant button.
 *
 * Replaces the standalone "AI Помощник" tab. Available everywhere; opens a
 * compact chat dialog with the unified Nutribot+Endobot vector store.
 */
import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import WhAiBotChat from "./WhAiBotChat";
import { Brain } from "lucide-react";

export default function WhFloatingAi({ API, isDark }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed bottom-24 right-6 z-[9998] w-14 h-14 rounded-full bg-gradient-to-br from-pink-500 to-fuchsia-500 text-white shadow-lg hover:shadow-xl transition-shadow flex items-center justify-center"
        aria-label="AI Помощник"
        data-testid="wh-floating-ai-btn"
      >
        <Brain className="w-6 h-6" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-lg bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 border-slate-200 dark:border-slate-700 max-h-[88vh] overflow-y-auto" data-testid="wh-floating-ai-dialog">
          <DialogHeader>
            <DialogTitle>AI Здравен Помощник</DialogTitle>
            <DialogDescription>
              Питай за хранене, хормони, цикъл или симптоми. Образователно, не медицинска консултация.
            </DialogDescription>
          </DialogHeader>
          <WhAiBotChat API={API} isDark={isDark} defaultBot="auto" />
        </DialogContent>
      </Dialog>
    </>
  );
}
